import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import { Box, IconButton } from "@mui/material"
import { UserDto } from "@custom-types/user"
import { useDeleteUserMutation } from "@store/services/usersService"
import { useCallback, useEffect, useMemo, useState } from "react"
import DeleteDialog from "@components/DeleteDialog"
import { getMaterialTableColumns } from "./const"
import { Table } from "@components/Table"
import { MRT_ColumnDef, MRT_Row } from "material-react-table"

interface IUsersTableProps {
  data: UserDto[] | undefined
  onDeleteClick?: () => void
  onEditClick?: (id: string) => void
}

export default function UsersTable({ data = [], onEditClick, onDeleteClick }: IUsersTableProps) {
  const [isDeleteOpen, setIsDeleteOpen] = useState(false)
  const [deleteUser, { isSuccess: isDeleteUserSuccess }] = useDeleteUserMutation()
  const [selectedRowKey, setSelectedRowKey] = useState<string | null>(null)

  const materialTableColumns: MRT_ColumnDef<UserDto>[] = useMemo(
    () => getMaterialTableColumns(),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
    [getMaterialTableColumns],
  )

  const getRowActions = useCallback(
    ({ row }: { row: MRT_Row<UserDto> }) => (
      <Box sx={{ display: "flex", gap: "4px" }}>
        <IconButton onClick={() => onEditClick?.(row.original.key)}>
          <EditIcon />
        </IconButton>
        <IconButton
          onClick={() => {
            setIsDeleteOpen(true)
            setSelectedRowKey(row.original.key)
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
    [],
  )

  useEffect(() => {
    if (isDeleteUserSuccess) {
      onDeleteClick?.()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  }, [isDeleteUserSuccess])

  return (
    <>
      <Box sx={{ mb: 4 }}>
        <Table
          sessionStorageName={"usersTable"}
          isExportable
          enableRowActions
          columns={materialTableColumns}
          data={data}
          renderRowActions={getRowActions}
        />
      </Box>
      <DeleteDialog
        open={isDeleteOpen}
        setOpen={setIsDeleteOpen}
        onDeleteClick={() => selectedRowKey && deleteUser(selectedRowKey)}
      />
    </>
  )
}
